module.exports = __webpack_public_path__ + "static/media/Savings_Diagram_Desktop_AE_EN.db86fa80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Savings_Diagram_Desktop_AE_EN.png
// module id = 560
// module chunks = 0